export const NAVIGATION_TABS = {
  JOBS: 'jobs',
  EDI_JOBS: 'edi-jobs',
};
